function useCookieValue(name) {
    let value = undefined;

    const cookie = `; ${document.cookie}`;
    const parts = cookie.split(`; ${name}=`);
    if (parts.length === 2) {
        value = parts.pop().split(';').shift();
    }

    return value;
}

export default useCookieValue;